import "./App.css";
import React, { Suspense, lazy } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Components/Assets/css/style.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PageLoader } from "./Components/componentsCollection";

// import Home from "./Components/Home";
// import HomeAfter from "./Components/HomeAfter";
// import ProfileWallet from "./Components/ProfileWallet";
// import Hoc from './Components/Hoc';
// import Cards from "./Components/Cards";
// import Roulette from "./Components/Roulette";
// import Pocker from "./Components/poker";
// import FastGame from "./Components/FastGame";
// import Sports from "./Components/Sports";
// import PrivacyPolicy from "./Components/PrivacyPolicy";

const Home = lazy(() => import('./Components/Home'));
const HomeAfter = lazy(() => import('./Components/HomeAfter'));
const ProfileWallet = lazy(() => import('./Components/ProfileWallet'));
const Hoc = lazy(() => import('./Components/Hoc'));
const Cards = lazy(() => import('./Components/Cards'));
const Roulette = lazy(() => import('./Components/Roulette'));
const Poker = lazy(() => import('./Components/poker'));
const FastGame = lazy(() => import('./Components/FastGame'));
const Lottery = lazy(() => import('./Components/Lottery'));
const LiveDealer = lazy(() => import('./Components/liveDealer'));
const TableGame = lazy(() => import('./Components/TableGame'));
const Slots = lazy(() => import('./Components/Slots'));
const PrivacyPolicy = lazy(() => import('./Components/PrivacyPolicy'));


function App() {
  let auth;
  auth = localStorage.getItem("auth");

  return (
    <div className="App">
      <ToastContainer />

      <Router>
        <Switch>
          <Route path="/home">
            <Suspense fallback={<PageLoader />}>
              <HomeAfter />
              {/* <Hoc comp={HomeAfter}/> */}
            </Suspense>
          </Route>
          <Route path="/cards">
            <Suspense fallback={<PageLoader />}>
              <Cards />
            </Suspense>
          </Route>
          <Route path="/roulette">
            <Suspense fallback={<PageLoader />}>
              <Roulette />
            </Suspense>
          </Route>
          <Route path="/poker">
            <Suspense fallback={<PageLoader />}>
              <Poker />
            </Suspense>
          </Route>
          <Route path="/fastgame">
            <Suspense fallback={<PageLoader />}>
              <FastGame />
            </Suspense>
          </Route>
          <Route path="/lottery">
            <Suspense fallback={<PageLoader />}>
              <Lottery />
            </Suspense>
          </Route>
          <Route path="/livedealer">
            <Suspense fallback={<PageLoader />}>
              <LiveDealer />
            </Suspense>
          </Route>
          <Route path="/table">
            <Suspense fallback={<PageLoader />}>
              <TableGame />
            </Suspense>
          </Route>
          <Route path="/slots">
            <Suspense fallback={<PageLoader />}>
              <Slots />
            </Suspense>
          </Route>
          <Route path="/privacy-policy">
            <Suspense fallback={<PageLoader />}>
              <PrivacyPolicy />
            </Suspense>
          </Route>
          <Route path="/wallet">
            <Suspense fallback={<PageLoader />}>
              {/* <ProfileWallet /> */}
              <Hoc comp={ProfileWallet} />
            </Suspense>
          </Route>
          <Route path="/">
            <Suspense fallback={<PageLoader />}>
              {
                !auth ? <Home /> : <HomeAfter />
              }
            </Suspense>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
